import React from "react";
import {IRouteProps, IViewProps} from "../../../ts/manager/view/ViewInterface";

const NoInternetBodyPartial = (props:IRouteProps|IViewProps) =>
{
    return <section className="content-block">
        <div className="container">
            <div className="row">

                <div className="col-12 text-center">
                    No internet connection
                </div>
            </div>
        </div>
    </section>
}

export default NoInternetBodyPartial;